import React, { Component } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";

import { setA11yContent } from "../NavigationHelper/actions";
import { media,isMobile } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import Alert from "common-components/Alert";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import { Select as ReactSelect } from "common-components/FormContent";
import { TitleLockup } from "@vds/type-lockups";
import {DropdownSelect } from "@vds/selects";
import { Title } from "@vds/typography"
import { TextLink } from "@vds/buttons";
import { deletePersonalData } from "./actions";
import FallbackUI from "../FallbackUI/FallbackUI";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { fetchPageContent } from "../DownloadAndDelete/actions";
import { ENDPOINTS } from "utils/endpoints";
import { FormerCustomerDeleteModal } from "./modals";
import { FormerPendingRequest } from "./FormerPendingRequest";
import { checkPendingCases, createCase, breadcrumbsLink } from "./actions/commonFormerCustomerAPI";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
class FormerCustomerDeleteInformation extends Component {
  state = {
    visibleModal: false,
    selectedAccount: ""
  };

  componentDidMount() {
    let url;
    url = ENDPOINTS.FETCH_FORMER_CUSTOMER_DELETE_PAGES_NEW;
    this.props.fetchPageContent(url).then(() => {
      if (checkNestedObject(this.props.deleteMarketingPrimerPage, "sc_pagetitle")) {
        this.props.setA11yContent("delete information", this.props.deleteMarketingPrimerPage.sc_pagetitle);
      }
      const { formerIdInfo, accountList } = this.getFormerIdAndAccounts();
      if (formerIdInfo && formerIdInfo.trim().length > 0) {
        this.props.setBreadcrumbList([]);
        if (accountList && accountList.length > 0) {
          this.setState({ selectedAccount: accountList[0] });
        }
      }
    });
  }

  handleModalPopup = () => {
    this.setState({ visibleModal: !this.state.visibleModal });
  };

  showDeleteOptions = () => {
    this.props.history.push({
      pathname: "/privacy/your-data/former-customer/deleteOptions",
      state: {
        confirmAuth: true,
        currentIntent: "delete",
        serviceType: "former"
      }
    });

  }

  handleDeleteClick = () => {
    const intent = "DeleteAccount";
    const selectedAcc = this.state.selectedAccount;
    const accountIdentifiers = window.reactGlobals.formerAcctsInfo.accountIdentifiers ? window.reactGlobals.formerAcctsInfo.accountIdentifiers : [];
    let payload = {};
    let valueObj = {};
    if (accountIdentifiers && accountIdentifiers.length > 0) {
      accountIdentifiers.forEach(accID => {
        valueObj[accID.identifier] = accID.value;
      })
    }
    if (selectedAcc) {
      payload = {
        intent,
        email: valueObj['emailId'] ? valueObj['emailId'] : null,
        profileId: valueObj['uuId'] ? valueObj['uuId'] : null,
        FirstName: valueObj['firstName'] ? valueObj['firstName'] : null,
        lastName: valueObj['lastName'] ? valueObj['lastName'] : null,
        address: {
          addressLine1: valueObj['address'] ? valueObj['address'] : null,
          city: valueObj['city'] ? valueObj['city'] : null,
          state: valueObj['state'] ? valueObj['state'] : null,
          zipCode: valueObj['zip'] ? valueObj['zip'] : null
        },
        serviceType: "former"
      }
    }
    let authTokenString = window.location.search;
    this.props.createCase(
      payload.email,
      payload.profileId,
      payload.FirstName,
      payload.lastName,
      payload.intent,
      null,
      payload.serviceType,
      null,
      selectedAcc.billingAccountNumber,
      payload.address
    ).then(() => {
      if (!this.props.error) {
        const route = "/privacy/your-data/former-customer/delete-confirmation" + authTokenString;
        const next = () =>
          this.props.history.push(route, {
            nextRoute: "/privacy/your-data/former-customer",
            deleteConfirmationContent: this.props.deleteConfirmationPage
          });
        next();
      } else {
        this.setState({ visibleModal: false });
      }
    });
  }

  handleContinueClick = () => {
    if (this.props.skipVerification) {
      const intent = "DeleteAccount";
      const accountID = this.state.selectedAccount ? this.state.selectedAccount.billingAccountNumber : null;
      this.props.checkPendingCases(null, intent, null, null, accountID).then(() => {
        if (!this.props.error) {
          if (this.props.isCasePending) {
            this.setState({ pendingModal: true })
          } else {
            this.handleModalPopup();
          }
        }
      });
      return;
    } else {
      this.showDeleteOptions();
      return;
    }
  }

  handleAccountChange = (event) => { 
    const selectedAccountIdx = parseInt(event.target.value);
    const { formerIdInfo, accountList } = this.getFormerIdAndAccounts();
    if (formerIdInfo && accountList) {
      const selectedAccount = accountList.filter((accountInfo, idx) => idx === selectedAccountIdx);
      if (selectedAccount) {
        this.setState({ selectedAccount: selectedAccount[0] });
      }
    }
  }

  getFormerIdAndAccounts = () => {
    const formerIdInfo = window.reactGlobals.formerAcctsInfo ? window.reactGlobals.formerAcctsInfo.formerId : "";
    let accountList = [];
    if (formerIdInfo) {
      accountList = window.reactGlobals.formerAcctsInfo.accountInfo ? window.reactGlobals.formerAcctsInfo.accountInfo : [];
    }
    return {
      formerIdInfo,
      accountList
    };
  }

  handleRequestHistoryClick = () => {
    const queryString = window.location.search;
    let currentPageName = window.location.pathname + queryString;
    const route = "/privacy/your-data/request-history"

    let pageLink;
    pageLink = [
      { requestStatusPageName: currentPageName },
      { requestHistoryPageName: route },
      { isSelectBox: this.props.skipVerification },
    ]
    this.props.breadcrumbsLink(pageLink)
    this.props.history.push(route, {
      nextRoute: "/privacy/your-data/former-customer",
      PreviouspageName: currentPageName
    });

  }

  render() {
    if (this.props.loading) {
      return <RectangleLoader />;
    }
    const { deleteMarketingPrimerPage, modalContent, requestPending } = this.props;
    let pageContent = deleteMarketingPrimerPage;
    const { accountList } = this.getFormerIdAndAccounts();
    if (this.props.error) {
      return <FallbackUI />;
    } else if (!pageContent) {
      return <FallbackUI />;
    } else {
      return (
        <div>
          <Container noTabletPadding>
            {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}
            <div style={{ maxWidth: "596px" }}>
              <div style={{width: isMobile ? "100%" : "332px", marginBottom: "40px"}}>
              {this.props.skipVerification && (
                <DropdownSelect data-testId="accountSelection" onChange={(e) => this.handleAccountChange(e)} >
                  {
                    accountList.map((accountInfo, idx) => (
                      <option key={accountInfo.billingAccountNumber + "_" + accountInfo.indicator + "_" + idx} value={idx}>
                        {accountInfo.firstName} {accountInfo.lastName} : {accountInfo.billingAccountNumber}
                      </option>
                    ))
                  }
                </DropdownSelect>
              )}
              </div>
              {/* VDS DPCMP-3786 ,DPCMP-3784 */}

              <TitleLockup
            data={{
              title: {
                size: 'titleXLarge',
                bold: false,
                children: pageContent.section_title 
              },
              subtitle : {
                size: 'titleMedium',
                children: pageContent.icontexts.map(item => (
                            <Div key={item.text}>
                              <Title size="medium" color="#000000" bold={true}>{convertStringToElements(item.headingText)}</Title>
                                {convertStringToElements(item.text)}
                            </Div>
                    ))
                }                  
            }}
          />
            
              {this.props.skipVerification ?
                <TextLink
                  type="inline"
                  onClick={this.handleRequestHistoryClick}>
                  {pageContent.buttons[2].text}
                </TextLink>
                : null}
            </div>
            <ButtonContainer>
              <Button background={pageContent.buttons[0].type} onClick={this.handleContinueClick}>
                {pageContent.buttons[0].text}
              </Button>
              <Button
                role="link"
                background={pageContent.buttons[1].type}
                onClick={() => this.props.history.goBack()}
              >
                {pageContent.buttons[1].text}
              </Button>
            </ButtonContainer>
          </Container>
          {this.state.visibleModal && (
            <FormerCustomerDeleteModal
              visibleModal={this.state.visibleModal}
              closeModal={this.handleModalPopup}
              modalContent={modalContent}
              deletePersonal={this.props.skipVerification}
              handleDeleteClick={this.handleDeleteClick}
            />
          )}
          {this.state.pendingModal && this.props.skipVerification ?
            <FormerPendingRequest
              modalContent={requestPending}
              dateOfRequest={"date"}
              closeModal={() => {
                this.setState({
                  pendingModal: !this.state.pendingModal
                }, () => {
                  this.props.history.push("/privacy/your-data/former-customer/your-deletable");
                  return;
                })
              }}
            /> : ""
          }
        </div>
      );
    }
  }
}

const mapStateToProps = ({
  pageContent: {
    delete_information_former: deleteMarketingPrimerPage,
    delete_review_former: modalContent,
    delete_confirmation_former: deleteConfirmationPage,
    pending_modal: requestPending,
  },
  loadingAndErrorState: { loading, error },
  pendingCase: { isCasePending },
}) => ({
  modalContent,
  deleteMarketingPrimerPage,
  deleteConfirmationPage,
  loading,
  error,
  isCasePending,
  requestPending
});

export default compose(
  connect(
    mapStateToProps,
    {
      setA11yContent,
      deletePersonalData,
      fetchPageContent,
      checkPendingCases,
      createCase,
      breadcrumbsLink,
      setBreadcrumbList
    }
  ),
)(FormerCustomerDeleteInformation);

FormerCustomerDeleteInformation.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
  fetchPageContent: PropTypes.func.isRequired,
  pageContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
    padding: 48px 16px ;
  `}
`;

const Div = styled.div`
  margin: 32px 0 0;

  p {
    margin: 12px 0 0;
    font-size: 16px;
    line-height: 20px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-weight: 400;
    max-width: 598px;
  }

  p strong {
    font-size: 20px;
    line-height: 19px;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }

  ul {
    list-style: disc inside;
    margin: 15px 0;
    font-size: 16px;
    line-height: 20px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-weight: 400;
    max-width: 598px;
  }
  li {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 48px;
  display:flex;
  button,
  a {
    width: 172px;
  }
  ${media.mobile`
    flex-direction: column;  
  `}
`;

const Select = styled(ReactSelect)`
  width: 332px !important;
  padding: 12px !important;
  min-width: inherit !important;
  height: inherit !important;
  margin-bottom: 40px;
`;

const Header = styled.h1`
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 24px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight : 300;
${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight : 400
`}
`;

const P = styled.p`
  font-size: 24px !important;
  line-height: 28px !important;
  font-weight: 700 !important;
  max-width: 596px !important;

  ${media.mobile`
  font-size: 20px;	
  line-height: 24px;
`}
`;
const RequestHistoryButton = styled.div`
  button {
    background: transparent;
    border: none;
    text-decoration: underline;
    font-size: 16px;
    line-height: 20px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-weight: 400;
    cursor: pointer;
  }
`;